import type { FC } from "react";

import { Card, CardRowSimple, type GridCard, LoadingSpinner } from "widgets";

import { SampleParentTile } from "../../core/tiles";
import { useError } from "@/app-utils/graphql/useError.ts";
import { useNotificationSummaryViewUpdate } from "@/app-utils/hooks/useNotificationUpdate.ts";
import type { Parent, Sample } from "@/graphql.ts";
import { ContentPlaceholder } from "@/ui-modules/core/ContentPlaceholder.tsx";
import { SamplesStackTile } from "@/ui-modules/entities/samples/SamplesStackTile.tsx";
import { useGetPlaybookEventRelatedSamplesQuery } from "@/ui-modules/playbooks/events/graphql/event-queries.gql.ts";

interface IPlaybookEventSamplesCardProps extends GridCard {
  eventId: number;
}

export const PlaybookEventSamplesCard: FC<IPlaybookEventSamplesCardProps> = (props) => {
  const { data, loading, error, refetch } = useGetPlaybookEventRelatedSamplesQuery({
    variables: { eventId: props.eventId },
  });
  void useError(error);
  useNotificationSummaryViewUpdate(refetch, props.eventId);

  const playbookEvent = data?.playbook?.event;

  return (
    <Card key="event-samples-card" title={"Related Samples"} {...props}>
      {loading ? (
        <LoadingSpinner />
      ) : !playbookEvent?.parents?.length && !playbookEvent?.relatedSamples?.length ? (
        <ContentPlaceholder>No related samples</ContentPlaceholder>
      ) : (
        <CardRowSimple>
          {playbookEvent.parents?.map((parent) => <SampleParentTile parent={parent as Parent} key={parent.id} />)}
          <SamplesStackTile samples={playbookEvent.relatedSamples as Sample[]} />
        </CardRowSimple>
      )}
    </Card>
  );
};
